/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2015, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../TransitionController'
], function(BaseClass) {
	'use strict';

	var PanAndZoomTransitionController = PanAndZoomTransitionController = BaseClass.extend({

		_duration: null,

		_cssOnScreen: {
			display: 'block',
			position: 'absolute',
			top: '0px',
			bottom: '0px',
			left: '0px',
			right: '0px'
		},

		init: function(options) {
			PanAndZoomTransitionController.inherited('init', this, arguments);
			this._duration = options.duration ? options.duration : 800;
			this._impress = options.impress;
		},

		_beforeJump: function(from) {
			this._hideWidgets(from);
			return PanAndZoomTransitionController.inherited('_beforeJump', this, arguments);
		},

		_afterJump: function(from, to) {
			this._showWidgets(to);
			return PanAndZoomTransitionController.inherited('_afterJump', this, arguments);
		},

		_jump: function(from, to) {
			this._impress.goto(to.$el[0].id);

			return PanAndZoomTransitionController.inherited('_jump', this, arguments);
		},

		_beforeNext: function(from, to) {
			this._showWidgets(to);

			return PanAndZoomTransitionController.inherited('_beforeNext', this, arguments);
		},

		_next: function(from, to) {
			this._impress.goto(to.$el[0].id);
			return Promise.resolve();
		},

		_afterNext: function(from /*, to*/) {
			this._hideWidgets(from);
			return PanAndZoomTransitionController.inherited('_afterNext', this, arguments);
		},

		_beforePrevious: function(from, to) {
			this._showWidgets(to);
			return PanAndZoomTransitionController.inherited('_beforePrevious', this, arguments);
		},

		_previous: function(from, to) {
			this._impress.goto(to.$el[0].id);
			return Promise.resolve();
		},

		_afterPrevious: function(from) {
			this._hideWidgets(from);

			return PanAndZoomTransitionController.inherited('_afterPrevious', this, arguments);
		},

		deckScenes: function() {},

		undeckScenes: function() {}
	});

	return PanAndZoomTransitionController;
});
